export default __webpack_public_path__ + "static/photoelectric9-8fe234a484d65ff88d3c515d8ecf7ec4.png";